var map = {
	"./en.json": [
		1076,
		106
	],
	"./ro.json": [
		1077,
		107
	],
	"./ru.json": [
		1078,
		108
	],
	"./tr.json": [
		1079,
		109
	],
	"./widgets/en.json": [
		763,
		9
	],
	"./widgets/ro.json": [
		764,
		10
	],
	"./widgets/ru.json": [
		765,
		11
	],
	"./widgets/tr.json": [
		766,
		12
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 663;
module.exports = webpackAsyncContext;